import DropdownClassList from "root/s360components/ReactHookForm/ui/DropdownClassList";
import {FormInputDatePicker, SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import DropdownAMPM, {ALL_SESSION_OBJ, AM_OBJ, PM_OBJ} from "root/s360components/ReactHookForm/ui/DropdownAMPM";
import {
    ModalFutureAbsenceSectionsNames
} from "root/s360components/Modals/FutureAbsence/ModalFutureAbsence";
import BootstrapRow from "root/ReactHookForm/ui/BootstrapRow";
import DropdownAbsenceCode from "root/s360components/ReactHookForm/ui/DropdownAbsenceCode";
import './FutureAbsenceCreateFragment.scss';
import BootstrapCol from "root/ReactHookForm/ui/BootstrapCol";
import {useAbsenceCodesContext} from "root/s360components/Contexts/AbsenceCodes/AbsenceCodesContext";
import DropdownProviderEYFSGroupMembers from "root/ReactHookForm/ui/DropdownProviderEYFSGroupMembers";
import useWatchDropdown from "root/ReactHookForm/ui/useWatchDropdown";
import TextAreaRegComment from "root/s360components/ReactHookForm/ui/TextAreaRegComment";


const FutureAbsenceCreateFragment = ({school_id, sectionName, formErrors, control}) =>
{
    const sessionOptions = [
        AM_OBJ,
        PM_OBJ,
        ALL_SESSION_OBJ
    ]

    const {absenceCodes, loadingAbsenceCodes} = useAbsenceCodesContext();

    const [ groupId ] = useWatchDropdown( {control, name: sectionName + '.' + ModalFutureAbsenceSectionsNames.CLASS, isInt: false, namedField: 'group_id' }) ;

    const validateGroup = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Group/Class.";
        }
    }

    const validateChild = (val) =>
    {
        if (val === null)
        {
            return "Please Select a Pupil.";
        }
    }

    return (
        <form className='future-absence-create-frag'>
                <BootstrapRow>
                    <BootstrapCol width={4}>
                        <h5>Select a Group/Class</h5>
                        <DropdownClassList school_id={school_id}
                                           name={sectionName + '.' + ModalFutureAbsenceSectionsNames.CLASS}
                                           control={control} rules={{validate: validateGroup}}
                                           placeHolder='Pick a Group' readOnly={false}
                                           class_id_filter={null}/>
                        <SmartErrorDiv sectionName={sectionName} name={ModalFutureAbsenceSectionsNames.CLASS}
                                       formErrors={formErrors}/>
                    </BootstrapCol>
                    <BootstrapCol width={4}>
                        <h5>Select a Pupil</h5>
                        <DropdownProviderEYFSGroupMembers enc_group_id={groupId}
                                                          name={sectionName + '.' + ModalFutureAbsenceSectionsNames.PUPIL}
                                                          control={control} rules={{validate: validateChild}}
                                                          placeHolder='Pick a Child'
                                                          readOnly={groupId === null}/>
                        <SmartErrorDiv sectionName={sectionName} name={ModalFutureAbsenceSectionsNames.PUPIL}
                                       formErrors={formErrors}/>
                    </BootstrapCol>
                    <BootstrapCol width={4}>
                        <h5>Select a reason</h5>
                        <DropdownAbsenceCode absenceCodes={absenceCodes} loadingAbsenceCodes={loadingAbsenceCodes} control={control}
                                                 fieldName={sectionName + '.' + ModalFutureAbsenceSectionsNames.ABS_CODE} menuPlacement={'bottom'} minMenuHeight={80}/>
                    </BootstrapCol>
                </BootstrapRow>

                <BootstrapRow>
                    <BootstrapCol width={4}>
                        <FormInputDatePicker control={control} sectionName={sectionName}
                                             name={ModalFutureAbsenceSectionsNames.ABS_FROM}
                                             formErrors={formErrors} readOnly={false} label={'From'}/>
                    </BootstrapCol>
                    <BootstrapCol width={4}>
                        <FormInputDatePicker control={control} sectionName={sectionName}
                                             name={ModalFutureAbsenceSectionsNames.ABS_TO}
                                             formErrors={formErrors} readOnly={false} label={'To'}/>
                    </BootstrapCol>
                    <BootstrapCol width={4}>
                        <label>Select a session</label>
                        <DropdownAMPM control={control}
                                      name={sectionName + '.' + ModalFutureAbsenceSectionsNames.SESSION}
                                      readOnly={false} placeholder={"Please select a time"} options={sessionOptions}/>
                    </BootstrapCol>
                </BootstrapRow>

                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <label>Notes</label>
                        <TextAreaRegComment control={control} fieldName={sectionName + '.' + ModalFutureAbsenceSectionsNames.NOTES} height={'200px'}/>
                    </BootstrapCol>
                </BootstrapRow>

            </form>
    )
}

export default FutureAbsenceCreateFragment;